// 扩展 f-eureka 的枚举值，定义 drafting 项目特有的
export enum DRAFTING_EMPOWER_TYPE {
    DRAFTING_HOME = 'DRAFTING_HOME',
    PATENT_DRAFTING = 'PATENT_DRAFTING',
    TEMPLATE_EDITOR = 'TEMPLATE_EDITOR',
    AI_INSTRUCTIONS = 'AI_INSTRUCTIONS',
    DIAGRAM_EDITOR = 'DIAGRAM_EDITOR',
}

export enum DRAFTING_CHANNEL_SOURCE {
    DRAFTING_EUREKA = 'dialog_signup_drafting_eureka',
}
